var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 17.1667C16.6666 17.3877 16.5788 17.5996 16.4226 17.7559C16.2663 17.9122 16.0543 18 15.8333 18H4.16665C3.94563 18 3.73367 17.9122 3.57739 17.7559C3.42111 17.5996 3.33331 17.3877 3.33331 17.1667V9.66667H0.833313L9.43915 1.84334C9.59257 1.70374 9.79255 1.62637 9.99998 1.62637C10.2074 1.62637 10.4074 1.70374 10.5608 1.84334L19.1666 9.66667H16.6666C16.6666 12.5956 16.6666 14.2377 16.6666 17.1667Z",
    fill: "#CEDFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16669 16.3333V11.3333H10.8334V16.3333H9.16669Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 10.4167,
    y1: 16.3333,
    x2: 12.3297,
    y2: 12.2239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B33E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92B6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeActive);
export default __webpack_public_path__ + "static/media/home-active.97a114dd5b253720406927000127612c.svg";
export { ForwardRef as ReactComponent };